import React from "react";

const SvgPrice = (props) => (
  <svg width={33} height={30} {...props}>
    <g transform="translate(-2 -7)" fill="none" fillRule="evenodd">
      <path
        d="M4.303 21.41a3.5 3.5 0 00-.19 5.237l9.123 8.692a1.5 1.5 0 001.94.11C23.96 28.797 29.524 24.024 31.84 21.16c2.24-2.769 2.813-10.006 1.6-11.756-1.037-1.497-11.06-1.394-13.703.163C17.308 11 12.153 14.953 4.303 21.41z"
        stroke="#082746"
      />
      <ellipse stroke="#082746" cx={27.117} cy={13.832} rx={2.767} ry={2.576} />
      <text
        transform="rotate(47 17.71 22.591)"
        fontFamily="AvenirNext-Bold, Avenir Next"
        fontSize={15}
        fontWeight="bold"
        fill="#082746"
      >
        <tspan x={12.864} y={27.591}>
          {"$"}
        </tspan>
      </text>
    </g>
  </svg>
);

export default SvgPrice;
